import TextInputColumnFilter from "../../../shared/table/TextInputColumnFilter";
export const TABLE_COLUMNS = [
  {
    Header: "Exception Deco",
    accessor: "exception_Deco",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Exception Pcat",
    accessor: "exception_Pcat",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Starting Color Count",
    accessor: "startingColorCount",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Ending Color Count",
    accessor: "endingColorCount",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Run Charge Type",
    accessor: "runChargeType",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Actions",
    id: "Actions",
  },

];
